/**
 * Blocks in Recent Information region
 *  - joining entity references form different blocks into "first - static" block
 */
const $ = window.jQuery;

export default {
  attach: function (context, _) {
    let $newContent = $(context);
    let $recentInfo = $newContent.find('.region-recent-information');
    let $customBlocks = $recentInfo.find('section.block');
    let $firstBlock = $customBlocks.first();
    let $firstBlockContent = $firstBlock.find('.field--name-field-content-reference');

    if ($recentInfo.length > 0 && $customBlocks.length > 1) {
      // Cloning nodes from other blocks and paste them into first block.
      $customBlocks.each(function (index, item){
        if (index > 0) {
          let $item = $(item);

          // Hide block.
          $item.hide();

          // Clone and append it in first block.
          let $nodes = $item.find('.field--name-field-content-reference')
            .children()
            .clone();

          $firstBlockContent.append($nodes);
        };
      });
    };

    // Add class to adopt paragraph styling.
    if(typeof $firstBlock != 'undefined') {
      $firstBlockContent.addClass('paragraph__content');
    };

    // Show region because it's hidden as default.
    $recentInfo.show();
  },
}
